module.exports = __webpack_public_path__ + "img/sihu.9fdca745.png";